import Vue from "vue";

import "normalize.css/normalize.css"; // A modern alternative to CSS resets

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import dayjs from "dayjs";
import './element-variables.scss'
import VCharts from "v-charts";

import "@/styles/index.scss"; // global css

import App from "./App";
import router from "./router";
import store from "./store";

import "@/icons"; // icon
import "@/permission"; // permission control

Vue.use(ElementUI);
Vue.use(VCharts);

// 树形表格
// import "xe-utils";
import VXETable from "vxe-table";
import 'vxe-table/lib/style.css'
// import "vxe-table/lib/index.css";
Vue.use(VXETable);

// 全局挂载dayjs
Vue.prototype.$dayjs = dayjs;

import directive from './directive' // directive
Vue.use(directive);

Vue.config.productionTip = false;

new Vue({
  el: "#app",
  router,
  store,
  template: "<App/>",
  components: { App }
});



// WEBPACK FOOTER //
// ./src/main.js